import React from 'react'
import ApplicationForm from './ApplicationForm'
import "./index.css"

export function App() {
  return <ApplicationForm />
}

export default App
